import { Action } from 'redux'
import { UserProfileActions } from '../../../reducers/userObject/actionNames'

const requestDeleteLogo = (): IRequestDeleteLogo => ({
  type: UserProfileActions.RequestDeleteUserProfileLogo,
})

export interface IRequestDeleteLogo
  extends Action<UserProfileActions.RequestDeleteUserProfileLogo> {
  type: UserProfileActions.RequestDeleteUserProfileLogo
}

const requestDeleteLogoAccepted = () => ({
  type: UserProfileActions.RequestDeleteUserProfileLogoAccepted,
})

export interface IRequestDeleteLogoAccepted
  extends Action<UserProfileActions.RequestDeleteUserProfileLogoAccepted> {
  type: UserProfileActions.RequestDeleteUserProfileLogoAccepted
}

export { requestDeleteLogoAccepted, requestDeleteLogo }
